import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static targets = ["photo"];

  connect() {
    this.observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            this.dropPhotos();
            this.observer.disconnect();
          }
        });
      },
      { threshold: 0.4 }
    );

    this.observer.observe(this.element);

    this.photoTargets.forEach((photo, index) => {
      photo.addEventListener("mouseenter", () => this.spreadPhotos(index));
      photo.addEventListener("mouseleave", () => this.resetPhotos());
    });
  }

  disconnect() {
    this.observer?.disconnect();
  }

  dropPhotos() {
    this.photoTargets.forEach((photo, index) => {
      setTimeout(() => {
        photo.classList.add("photo-dropped");
      }, index * 300);
    });
  }

  spreadPhotos(hoveredIndex) {
    this.photoTargets.forEach((photo, index) => {
      if (index < hoveredIndex) {
        photo.style.transform = `translateX(-30px)`;
      } else if (index > hoveredIndex) {
        photo.style.transform = `translateX(30px)`;
      } else {
        photo.style.transform = `scale(1.05)`;
        photo.style.zIndex = "100";
      }
    });
  }

  resetPhotos() {
    this.photoTargets.forEach((photo) => {
      photo.style.transform = "";
      photo.style.zIndex = "";
    });
  }
}
